import { Button } from '@shared/ui/Button';
import { IconBarChart, IconChevronDown } from '@shared/ui/icons';
import { formatMoney } from '../financierFormat';
import {
  CompactSummaryBar,
  CompactSummaryText,
  CompactMetric,
} from './styled';
import { STAGE_LABELS, type PipelineMetrics } from './types';

interface CompactSummaryProps {
  pipelineStage: string;
  metrics: PipelineMetrics;
  isDashboardLoading: boolean;
  isDashboardError: boolean;
  availableCash: number | null;
  coveragePct: number | null;
  onExpand: () => void;
}

export function CompactSummary({
  pipelineStage,
  metrics,
  isDashboardLoading,
  isDashboardError,
  availableCash,
  coveragePct,
  onExpand,
}: CompactSummaryProps) {
  return (
    <CompactSummaryBar>
      <CompactSummaryText>
        <CompactMetric>
          <strong>Этап:</strong> {STAGE_LABELS[pipelineStage] || pipelineStage}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Утверждено:</strong> {formatMoney(metrics.approvedAmount)}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Не оплачено:</strong> {formatMoney(metrics.unpaidTotal)}
        </CompactMetric>
        <span>|</span>
        <CompactMetric>
          <strong>Кэш:</strong>{' '}
          {isDashboardLoading
            ? 'Загрузка…'
            : isDashboardError
            ? 'Ошибка'
            : availableCash !== null
            ? formatMoney(availableCash)
            : '—'}
        </CompactMetric>
        {coveragePct !== null && (
          <>
            <span>|</span>
            <CompactMetric>
              <strong>Покрытие:</strong> {Math.round(coveragePct)}%
            </CompactMetric>
          </>
        )}
      </CompactSummaryText>
      <Button
        $variant="ghost"
        $size="sm"
        onClick={onExpand}
        aria-label="Развернуть блок аналитики"
      >
        <IconBarChart size={14} />
        Развернуть аналитику
        <IconChevronDown size={14} />
      </Button>
    </CompactSummaryBar>
  );
};
